module.exports = __webpack_public_path__ + "static/media/logo_nav.72a03b8c.gif";